import actions from '../../actions/types'

const state = {
  typesAereoporti: actions.getTypesAereoporti(),
  typesRating: actions.getTypesRating()
}

const getters = {
  getTypesAereoporti: state => {
    return state.typesAereoporti
  },
  getTypesRating: state => {
    return state.typesRating
  }
}

export default {
  state,
  getters
}



// WEBPACK FOOTER //
// ./src/front/store/modules/types.js